<!--Element单选树形控件-->
<template>
	<div class="elUnitTreeBody">
		<el-scrollbar style="height:calc(100% - 130px);width: 100%;">
			<el-tree :data="dataList" :expand-on-click-node="false" :current-node-key='defaultUnitId' node-key="id" :props="defaultProps" :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
				<span class="custom-tree-node" slot-scope="{node}">
			    <img src="../../../../public/static/image/elTree/1.9.png"/>
			 	<span style="padding-left: 5px;">{{node.label}}</span>
				</span>
			</el-tree>
		</el-scrollbar>
		<div style="height: 100px;">
			<el-divider>自动切换单位</el-divider>
			<div style="margin: 0 auto;">
				<label style="padding-left: 10px;padding-right: 10px;">时间间隔:</label>
				<el-input-number v-model="seconds" :min="6" :max="3600" size='mini'></el-input-number>
				<label style="padding-left: 10px;">秒</label>
			</div>
			<el-button @click="startAutoChange" type="primary" v-show="!changeStatus" size='mini' style='width:220px;margin-top: 10px;margin-left: 10px;'>开始自动切换</el-button>
			<el-button @click="stopAutoChange" type="primary" v-show="changeStatus" size='mini' style='width:220px;margin-top: 10px;margin-left: 10px;'>停止</el-button>
		</div>
	</div>
</template>
<script>
import {getReadDeviceTree} from '../../../api/abbNewApi.js'
	export default {
		components: {},
		props: {
			filterText: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				defaultUnitId: '',
				seconds: 60,
				changeStatus: false,
				nowIndex: -1
			}
		},
		created() {},
		mounted() {
			if(!isempty(this.dataList)) {
				this.defaultUnitId = this.dataList[0].id
			}
		},
		destroyed() {},
		computed: {
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowVirtualDevice() {
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			nowDevice() {
				let nowDevice = this.nowVirtualDevice
				if(!isempty(nowDevice)) {
					nowDevice.label = nowDevice.name
				}
				return nowDevice
			},
			defaultDevice() {
				if(isempty(this.nowDevice)) {
					if(!isempty(this.dataList)) {
						this.digui(this.dataList)
					}
				}
				return isempty(this.nowDevice) ? '' : this.nowDevice.pkid
			},
			dataList() {
				var data = this.$store.unitStore.getters.getUnitTree
				return isempty(data) ? [] : [unitList(data)]
			},
			unitList() {
				if (this.dataList.length == 0) {
					return []
				}
				return treeToList(this.dataList[0], 'children', item => item.hasOwnProperty('children'))
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			},
			dataList(nv, ov) {
				if(!isempty(this.dataList)) {
					this.defaultUnitId = this.dataList[0].id
				}
			},
		},
		methods: {
			filterNode(value, data) {
				if(!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			nodeClick(value, nodeData) {
				  getReadDeviceTree({'appType':"",'appTypeNos':'','unitId':value.id}).then(data => {
                        localStorage.setItem('treeList', JSON.stringify(data.data));
                  })
				value.name = value.label
				this.$emit('checkItem', value)
				this.$store.unitStore.commit("setNowUnit", value.id)
				this.$store.unitStore.commit("setUnitGroupNo", value.id)
			},
			// 开始自动切换
			startAutoChange() {
				this.stopAutoChange()
				this.changeStatus = true
				addNewTask('autoChangeTimer', this.seconds * 1000, this.seconds * 1000, -1, () => {
					if(this.nowIndex == this.unitList.length - 1) {
						this.nodeClick(this.unitList[0])
						this.nowIndex=-1
					} else {
						this.nodeClick(this.unitList[this.nowIndex + 1])
						this.nowIndex++
					}
				})
			},
			// 停止自动切换
			stopAutoChange() {
				this.changeStatus = false
				removeTask('autoChangeTimer')
			},
		}
	}
</script>

<style>
	.elUnitTreeBody {
		height: 99.8%;
		background-color: white;
		width: 2.5rem;
		border: 1px solid #ded7d7;
		border-radius: 0 0 10px 10px
	}
	
	.elUnitTreeBody .el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden !important;
	}
	
	.el-tree {
		margin-top: 5px;
	}
	
	.el-tree-node :nth-child(2) {
		padding: 1px;
		overflow: visible;
	}
	
	.elUnitTreeBody .el-input-number--mini .el-input-number__decrease,
	.el-input-number--mini .el-input-number__increase {
		display: none;
	}
	
	.elUnitTreeBody .el-divider--horizontal {
		margin-top: 10px;
	}
</style>